import {PayloadAction} from '@reduxjs/toolkit';
import creativeTemplateBaseReducer from './creativeTemplateBase/creativeTemplateBase.slice';
import creativeTemplateHomeTabReducer from './creativeTemplateHomeTab/creativeTemplateHomeTab.slice';
import dynamicParamsReducer from './dynamicParams/dynamicParams.slice';
import {CreativeTemplateBaseState} from './creativeTemplateBase/creativeTemplateBase.types';
import {CreativeTemplateHomeTabState} from './creativeTemplateHomeTab/creativeTemplateHomeTab.types';
import {DynamicParamsState} from './dynamicParams/dynamicParams.types';

export interface CreativeTemplatePageState extends CreativeTemplateBaseState {
  homeTab: CreativeTemplateHomeTabState;
  dynamicParams: DynamicParamsState;
}

// Custom reducer that flattens base properties while keeping other reducers nested
const creativeTemplatePageReducer = (
  state: CreativeTemplatePageState,
  action: PayloadAction,
): CreativeTemplatePageState => {
  const baseState = creativeTemplateBaseReducer(state, action);
  const homeTabState = creativeTemplateHomeTabReducer(state?.homeTab, action);
  const dynamicParamsState = dynamicParamsReducer(state?.dynamicParams, action);

  return {
    ...baseState,
    homeTab: homeTabState,
    dynamicParams: dynamicParamsState,
  };
};

export default creativeTemplatePageReducer;
